import { render, staticRenderFns } from "./childGoals.vue?vue&type=template&id=396e2569&"
import script from "./childGoals.vue?vue&type=script&lang=js&"
export * from "./childGoals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports